import { handleActions } from 'redux-actions';
import * as types from './types';

const initialState = {
  data: [],
  error: null,
  loading: false,
  saving: false,
};

const bulkInviteRequest = (state) => {
  return {
    ...state,
    error: null,
    saving: true,
  };
};
const bulkInviteRequestFailure = (state, action) => {
  return {
    ...state,
    error: action.error.message,
    saving: false,
  };
};
const bulkInviteRequestSuccess = (state, payload) => {
  return {
    ...state,
    error: null,
    saving: false,
  };
};

const getTeamRequest = (state) => {
  return {
    ...state,
    error: null,
    loading: true,
  };
};
const getTeamRequestFailure = (state, action) => {
  return {
    ...state,
    error: action.error,
    loading: false,
  };
};
const getTeamRequestSuccess = (state, payload) => {
  return {
    ...state,
    data: payload.data,
    error: null,
    loading: false,
  };
};

const inviteUserRequest = (state) => {
  return {
    ...state,
    error: null,
    saving: true,
  };
};
const inviteUserRequestFailure = (state, action) => {
  return {
    ...state,
    error: action.error.message,
    saving: false,
  };
};
const inviteUserRequestSuccess = (state, payload) => {
  return {
    ...state,
    error: null,
    saving: false,
  };
};

export default handleActions(
  {
    [types.BULK_INVITE_REQUEST]: bulkInviteRequest,
    [types.BULK_INVITE_REQUEST_FAILURE]: bulkInviteRequestFailure,
    [types.BULK_INVITE_REQUEST_SUCCESS]: bulkInviteRequestSuccess,
    [types.GET_TEAM_REQUEST]: getTeamRequest,
    [types.GET_TEAM_REQUEST_FAILURE]: getTeamRequestFailure,
    [types.GET_TEAM_REQUEST_SUCCESS]: getTeamRequestSuccess,
    [types.INVITE_USER_REQUEST]: inviteUserRequest,
    [types.INVITE_USER_REQUEST_FAILURE]: inviteUserRequestFailure,
    [types.INVITE_USER_REQUEST_SUCCESS]: inviteUserRequestSuccess,
  },
  initialState
);
